import React, { Component } from "react";
import axios from "axios";
import { withTranslation } from "react-i18next";
import "./shopReview.css";

class ShopReview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reviews: [],
      googleRating: 0,
      slottiRating: 0,
      totalGoogleReviews: 0,
      totalSlottiReviews: 0,
      reviewsCount: 0,
      slottiLinked: false,
      activeFilter: "all",
      loading: true,
      error: null,
      expandedCards: {},
    };
  }

  componentDidMount() {
    this.fetchReviews();
  }

  fetchReviews() {
    const apiUrl = `https://darkslateblue-mink-768848.hostingersite.com/api/reviews/ChIJjVIkuBYLiUYRpYZkA8uW4_c`;
    axios
      .get(apiUrl)
      .then((response) => {
        const data = response.data;
        const reviews = data.reviews || [];
        const place = data.place || {};

        this.setState({
          reviews,
          googleRating: Math.round((place.googleRating || 0) * 10) / 10,
          slottiRating: Math.round((place.slottiRating || 0) * 10) / 10,
          totalGoogleReviews: place.totalGoogleReviews || 0,
          totalSlottiReviews: place.totalSlottiReviews || 0,
          reviewsCount: data.reviewsCount || reviews.length,
          slottiLinked: place.slottiLinked || false,
          loading: false,
        });
      })
      .catch((error) => {
        console.error("Error fetching reviews:", error);
        this.setState({ error: "Failed to load reviews", loading: false });
      });
  }

  formatRelativeTime(timeStamp) {
    if (!timeStamp) return "";
    const now = new Date();
    const reviewDate = new Date(timeStamp);
    const diffMs = now - reviewDate;
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

    if (diffDays < 1) return this.props.t("reviews.today");
    if (diffDays === 1) return this.props.t("reviews.dayAgo");
    if (diffDays < 7) return `${diffDays} ${this.props.t("reviews.daysAgo")}`;
    const diffWeeks = Math.floor(diffDays / 7);
    if (diffWeeks === 1) return this.props.t("reviews.weekAgo");
    if (diffWeeks < 4) return `${diffWeeks} ${this.props.t("reviews.weeksAgo")}`;
    const diffMonths = Math.floor(diffDays / 30);
    if (diffMonths <= 1) return this.props.t("reviews.monthAgo");
    if (diffMonths < 12) return `${diffMonths} ${this.props.t("reviews.monthsAgo")}`;
    const diffYears = Math.floor(diffDays / 365);
    if (diffYears === 1) return this.props.t("reviews.yearAgo");
    return `${diffYears} ${this.props.t("reviews.yearsAgo")}`;
  }

  renderStars(rating) {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      if (i <= Math.floor(rating)) {
        stars.push(
          <span key={i} className="review-star filled">★</span>
        );
      } else if (i - rating < 1 && i - rating > 0) {
        stars.push(
          <span key={i} className="review-star half">★</span>
        );
      } else {
        stars.push(
          <span key={i} className="review-star empty">★</span>
        );
      }
    }
    return stars;
  }

  getFilteredReviews() {
    const { reviews, activeFilter } = this.state;
    return reviews
      .filter((r) => r.text && r.text.trim() !== "")
      .filter((r) => activeFilter === "all" || r.source === activeFilter)
      .sort((a, b) => (b.time || 0) - (a.time || 0))
      .slice(0, 10);
  }

  toggleExpand(index) {
    this.setState((prev) => ({
      expandedCards: {
        ...prev.expandedCards,
        [index]: !prev.expandedCards[index],
      },
    }));
  }

  render() {
    const { t } = this.props;
    const {
      googleRating,
      slottiRating,
      totalGoogleReviews,
      totalSlottiReviews,
      slottiLinked,
      activeFilter,
      loading,
      error,
    } = this.state;

    const filteredReviews = this.getFilteredReviews();

    if (loading) {
      return (
        <section className="review-section" id="reviews">
          <div className="container text-center">
            <div className="review-loading">
              <div className="spinner"></div>
            </div>
          </div>
        </section>
      );
    }

    if (error) {
      return null;
    }

    return (
      <section className="review-section" id="reviews">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 text-center">
              <h2 className="section-heading text-uppercase">
                {t("reviews.title")}
              </h2>
              <h3 className="review-section-subtitle">
                {t("reviews.subtitle")}
              </h3>
            </div>
          </div>

          {/* Rating Button with Header */}
          <div className="review-ratings-header">
           <button
              className={`review-filter-btn review-filter-btn--google ${activeFilter === "google" ? "active" : ""}`}
              onClick={() => this.setState({ activeFilter: activeFilter === "google" ? "all" : "google" })}
            >
              <img
                src="https://www.google.com/favicon.ico"
                alt="Google"
                className="review-source-icon"
              />
              <span className="review-source-name">Google</span>
              <span className="review-source-rating">{googleRating}</span>
              <span className="review-source-count">
                ({totalGoogleReviews} {t("reviews.reviewsCount")})
              </span>
            </button>
            {slottiLinked && (
              <button
                className={`review-filter-btn review-filter-btn--slotti ${activeFilter === "slotti" ? "active" : ""}`}
                onClick={() => this.setState({ activeFilter: activeFilter === "slotti" ? "all" : "slotti" })}
              >
                <img
                  src="https://play-lh.googleusercontent.com/Rw6DwyN33ElBJWrIIF3s7H76SDnznKnOQ7twMnE2UODtyLtugnBkC-pRSxCtzl52Hm60=w240-h480-rw"
                  alt="Slotti"
                  className="review-source-icon"
                />
                <span className="review-source-name">Slotti</span>
                <span className="review-source-rating">{slottiRating}</span>
                <span className="review-source-count">
                  ({totalSlottiReviews} {t("reviews.reviewsCount")})
                </span>
              </button>
            )}
          </div>
          {/* Review Cards */}
          <div className="review-grid">
            {filteredReviews.map((review, index) => {
              const isSlotti = review.source === "slotti";
              return (
                <div
                  className={`review-card ${isSlotti ? "review-card--slotti" : "review-card--google"}`}
                  key={review.id || index}
                >
                  <div className="review-card-header">
                    <div className="review-author-avatar">
                      {review.profilePhotoUrl ? (
                        <img
                          src={review.profilePhotoUrl}
                          alt={review.authorName}
                          className="review-avatar-img"
                          referrerPolicy="no-referrer"
                        />
                      ) : (
                        <div className="review-avatar-placeholder">
                          {review.authorName
                            ? review.authorName.charAt(0).toUpperCase()
                            : "?"}
                        </div>
                      )}
                    </div>
                    <div className="review-author-info">
                      <span className="review-author-name">
                        {review.authorName}
                      </span>
                      <span className="review-time">
                        {this.formatRelativeTime(review.timeStamp)}
                      </span>
                    </div>
                  </div>
                  <div className="review-card-rating">
                    {this.renderStars(review.rating)}
                  </div>
                  {review.text && (
                    <>
                      <p className={`review-card-text${this.state.expandedCards[index] ? " expanded" : ""}`}>{review.text}</p>
                      {review.text.length > 100 && (
                        <button
                          className="review-show-more"
                          onClick={() => this.toggleExpand(index)}
                        >
                          {this.state.expandedCards[index] ? t("reviews.showLess") : t("reviews.showMore")}
                        </button>
                      )}
                    </>
                  )}
                  <div className="review-card-footer">
                    {isSlotti ? (
                      <>
                        <img
                          src="https://play-lh.googleusercontent.com/Rw6DwyN33ElBJWrIIF3s7H76SDnznKnOQ7twMnE2UODtyLtugnBkC-pRSxCtzl52Hm60=w240-h480-rw"
                          alt="Slotti"
                          className="review-card-source-icon"
                        />
                        <span className="review-card-source-text">Slotti</span>
                      </>
                    ) : (
                      <>
                        <img
                          src="https://www.google.com/favicon.ico"
                          alt="Google"
                          className="review-card-source-icon"
                        />
                        <span className="review-card-source-text">Google</span>
                      </>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    );
  }
}

export default withTranslation("global")(ShopReview);